import type { Schemas } from '#shopware'
import { computed, type Ref } from 'vue'
import { extractWarrantyDataFromProduct } from '~/utils/warrantyLabel'

export interface WarrantyLabelData {
    show: boolean
    warrantyYears: number
    brand: string
    modelIdentifier: string
    conditionsLink: string
    mediaUrl: string | null
    useGeneratedSvg: boolean
}

/**
 * Composable for EU warranty label logic
 * Handles product-level overrides and manufacturer defaults
 */
export function useProductWarrantyLabel(product: Ref<Schemas['Product'] | undefined>) {
    const warrantyData = computed<WarrantyLabelData | null>(() => {
        const productData = product.value
        if (!productData?.manufacturer) return null

        return extractWarrantyDataFromProduct(productData, productData.manufacturer)
    })

    const hasWarrantyLabel = computed(() => warrantyData.value !== null)

    return {
        warrantyData,
        hasWarrantyLabel,
    }
}
